import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 flex items-center justify-center">
              <img
                src="/favicon.png"
                alt="Olympic Academy Logo"
                className="w-10 h-10 object-contain"
              />
            </div>
            <div>
              <h1
                className="text-xl font-bold text-gray-900"
                style={{
                  fontFamily: '"Inter", "Roboto", sans-serif',
                  fontWeight: "700",
                }}
              >
                Olympic Academy
              </h1>
            </div>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection("about")}
              className="text-gray-700 hover:text-green-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              Giới thiệu
            </button>
            <button
              onClick={() => scrollToSection("programs")}
              className="text-gray-700 hover:text-red-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              Chương trình
            </button>
            <button
              onClick={() => scrollToSection("achievements")}
              className="text-gray-700 hover:text-yellow-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              Thành tích
            </button>
            <button
              onClick={() => scrollToSection("teachers")}
              className="text-gray-700 hover:text-blue-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              Giảng viên
            </button>
            <button
              onClick={() => scrollToSection("contact")}
              className="bg-gradient-to-r from-blue-500 to-green-500 text-white px-6 py-2 rounded-full hover:from-blue-600 hover:to-green-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Liên hệ
            </button>
          </nav>

          <div className="flex items-center space-x-4">
            <button
              onClick={() => navigate("/login")}
              className="bg-gradient-to-r from-yellow-400 to-red-500 text-white px-6 py-2 rounded-lg hover:from-yellow-500 hover:to-red-600 transition-all whitespace-nowrap hidden md:block"
            >
              Đăng nhập
            </button>

            <button
              className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i
                className={`ri-${isMenuOpen ? "close" : "menu"}-line text-xl`}
              ></i>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden mt-4 py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection("about")}
                className="text-gray-700 hover:text-green-500 transition-colors cursor-pointer text-left whitespace-nowrap"
              >
                Giới thiệu
              </button>
              <button
                onClick={() => scrollToSection("programs")}
                className="text-gray-700 hover:text-red-500 transition-colors cursor-pointer text-left whitespace-nowrap"
              >
                Chương trình
              </button>
              <button
                onClick={() => scrollToSection("achievements")}
                className="text-gray-700 hover:text-yellow-500 transition-colors cursor-pointer text-left whitespace-nowrap"
              >
                Thành tích
              </button>
              <button
                onClick={() => scrollToSection("teachers")}
                className="text-gray-700 hover:text-blue-500 transition-colors cursor-pointer text-left whitespace-nowrap"
              >
                Giảng viên
              </button>
              <button
                onClick={() => scrollToSection("contact")}
                className="bg-gradient-to-r from-blue-500 to-green-500 text-white px-6 py-2 rounded-full hover:from-blue-600 hover:to-green-600 transition-all cursor-pointer text-center whitespace-nowrap"
              >
                Liên hệ
              </button>
              <button
                onClick={() => {
                  navigate("/login");
                  setIsMenuOpen(false);
                }}
                className="bg-gradient-to-r from-yellow-400 to-red-500 text-white px-6 py-2 rounded-lg hover:from-yellow-500 hover:to-red-600 transition-all whitespace-nowrap"
              >
                Đăng nhập
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
